<template>
  <v-container
    v-show="!$apollo.loading"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md11
        lg10
      >
        <h2 v-if="$route.name == 'New White Label'">
          {{ $t('whitelabel.newWhiteLabel') }}
        </h2>
        <h2 v-else>
          {{ $t('whitelabel.editWhiteLabel') }}
        </h2>
        <v-tabs :value="active_tab">
          <v-tab
            v-for="(n,i) in [$t('whitelabel.profile'), $t('whitelabel.design'), $t('whitelabel.subscriptionSetting'), $t('whitelabel.marketingSettings'), $t('whitelabel.supportSettings'), $t('whitelabel.paymentSettings'), $t('whitelabel.modulesSettings'), $t('whitelabel.settings')]"
            :key="i"
            @change="active_tab = i"
          >
            {{ n }}
          </v-tab>
        </v-tabs>
        <v-card>
          <v-form>
            <white-label-profile
              v-show="active_tab === 0"
              ref="tab0"
              :edit-form="whiteLabel"
              @saveForm="saveForm"
              @updateForm="updateForm"
            />
            <white-label-design
              v-show="active_tab === 1"
              ref="tab1"
              :edit-form="whiteLabel || initForm"
              @saveForm="saveForm"
            />
            <white-label-subscription
              v-show="active_tab === 2"
              ref="tab2"
              :edit-form="whiteLabel"
              @saveForm="saveForm"
            />
            <white-label-marketing
              v-show="active_tab === 3"
              ref="tab3"
              :edit-form="whiteLabel"
              @saveForm="saveForm"
            />
            <white-label-support
              v-show="active_tab === 4"
              ref="tab4"
              :edit-form="whiteLabel"
              @saveForm="saveForm"
            />
            <white-label-payment-gateways
              v-show="active_tab === 5"
              ref="tab5"
              :edit-form="whiteLabel"
              @saveForm="saveForm"
            />
            <white-label-modules
              v-show="active_tab === 6"
              ref="tab6"
              :edit-form="whiteLabel"
              @saveForm="saveForm"
            />
            <white-label-settings
              v-show="active_tab === 7"
              ref="tab7"
              :edit-form="whiteLabel"
              @saveForm="saveForm"
            />
            <v-layout>
              <v-flex
                xs12
                md12
              >
                <v-btn
                  fab
                  outlined
                  small
                  text
                  @click="$router.push('/whitelabels')"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn
                  color="primary"
                  style="float:right"
                  :disabled="loading"
                  :loading="loading"
                  @click="next"
                >
                  {{ ($route.params.uuid || (!$route.params.uuid && active_tab == 4)) ? $t('globals.saveButton') : $t('globals.nextButton') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WhiteLabelDesign from "@/views/WhiteLabel/partial/WhiteLabelDesign.vue";
import WhiteLabelProfile from "@/views/WhiteLabel/partial/WhiteLabelProfile.vue";
import WhiteLabelSubscription from "@/views/WhiteLabel/partial/WhiteLabelSubscription.vue";
import WhiteLabelMarketing from "@/views/WhiteLabel/partial/WhiteLabelMarketing.vue";
import WhiteLabelSupport from "@/views/WhiteLabel/partial/WhiteLabelSupport.vue";
import WhiteLabelPaymentGateways from "@/views/WhiteLabel/partial/WhiteLabelPaymentGateways.vue";
import WhiteLabelModules from "@/views/WhiteLabel/partial/WhiteLabelModules.vue";
import WhiteLabelSettings from "@/views/WhiteLabel/partial/WhiteLabelSetting.vue";

import UPDATE_WHITELABEL_MUTATION from "@/graphql/mutations/UpdateWhiteLabel.gql";
import CREATE_WHITELABEL_MUTATION from "@/graphql/mutations/CreateWhiteLabel.gql";
import EXTENDED_SUBSCRIPTION_UPDATE_MUTATION from "@/graphql/mutations/modules/ExtendedSubscriptionUpdate.gql";
import WHITE_LABEL_QUERY from "@/graphql/queries/WhiteLabel.gql";

import punycode from 'punycode/punycode';

export default {
  name: "WhiteLabelForm",
  components: {
    WhiteLabelProfile,
    WhiteLabelDesign,
    WhiteLabelSubscription,
    WhiteLabelMarketing,
    WhiteLabelSupport,
    WhiteLabelPaymentGateways,
    WhiteLabelModules,
    WhiteLabelSettings
  },
  data: () => ({
    active_tab: 0,
    domain: null,
    subdomain: null,
    initForm: null,
    loading: false,
    form: {}
  }),
  apollo: {
    whiteLabel: {
      fetchPolicy: "network-only",
      query() {
        return WHITE_LABEL_QUERY;
      },
      variables() {
        return {
          uuid: this.$route.params.uuid
        };
      },
      result(data) {
        if (!data.loading) {
          if (this.whiteLabel.domain) {
            this.whiteLabel.domain = punycode.toUnicode(this.whiteLabel.domain)
          }
          this.domain = this.whiteLabel.domain
          this.subdomain = data.data.whiteLabel.subdomain
          try {
            this.whiteLabel.subscription_available = JSON.parse(this.whiteLabel.subscription_available)
          } catch(e) {}
        }
      },
      skip() {
        return this.$route.params.uuid == undefined;
      },
    }
  },
  computed: {
    extendedSubscription() {
      return this.whiteLabel && this.whiteLabel.modules.find(item => item.module == 'extended_subscription') ? true : false
    },
  },
  methods: {
    saveForm(form) {
      this.form = {...this.form, ...form}
    },
    updateForm(form) {
      this.initForm = {...this.initForm, ...form}
    },
    next() {
      let tab = "tab" + this.active_tab;
      this.$refs[tab].save();

      if (
        this.$route.params.uuid == undefined &&
        (!this.$refs[tab].$v || !this.$refs[tab].$v.$invalid) &&
        this.active_tab < 7
      ) {
        this.active_tab += 1
        return;
      }

      for (let i = 0; i <= 7; i++) {
          this.$refs['tab'+i].save()
          if ((this.$refs['tab'+i].$v && this.$refs['tab'+i].$v.$invalid)
            || this.$refs['tab'+i].error) {
            this.active_tab = i;
            return
          }
      }

      Object.keys(this.form).forEach((k) => this.form[k] == null && delete this.form[k]);
      this.save();
    },
    saveExtendedSubscription() {
      let params = {}
      
      params.free_usage = this.form.free_usage
      params.free_usage_deposit = this.form.free_usage_deposit
      params.trial_period_days = this.form.trial_period_days
      params.whitelabel_uuid = this.whiteLabel.uuid
      this.$apollo
        .mutate({
          mutation: EXTENDED_SUBSCRIPTION_UPDATE_MUTATION,
          variables: params
        })
        .then(data => {
          this.loading = false;
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    },
    save() {
      this.loading = true;

      let mutation = CREATE_WHITELABEL_MUTATION;

      if (this.form.aff_plan_id) {
        this.form.aff_plan_id = parseInt(this.form.aff_plan_id)
      }

      if (!this.form.hasOwnProperty('aff_plan_id')) {
        this.form.aff_plan_id = null
      }

      if (this.domain && this.domain == this.form.domain) {
        delete(this.form.domain)
      } else if (this.form.domain) {
        this.form.domain = punycode.toASCII(this.form.domain)
      }

      if (this.subdomain && this.subdomain == this.form.subdomain) {
        delete(this.form.subdomain)
      }

      if (this.form.subscription_available &&  this.form.subscription_available.length == 0) {
        delete(this.form.subscription_available)
      }
      if (this.$route.params.uuid) {
        this.form.uuid = this.$route.params.uuid
        mutation = UPDATE_WHITELABEL_MUTATION;
      }

      if (this.extendedSubscription) {
        this.saveExtendedSubscription()
      }

      this.$apollo
        .mutate({
          mutation: mutation,
          variables: this.form
        })
        .then(data => {
          this.$router.push("/whitelabels");
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  }
}
</script>

<style lang="scss">
#project-name {
  text-transform: capitalize;
}
#project-ticker {
  text-transform: uppercase;
  font-weight: 700;
}
.md-radio {
  display: flex;
}
</style>
